export default __webpack_public_path__ + "static/media/logo_black.c7a0aa91.svg";